// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BaseText, Grid, Header2 } from '@catalytic/catalytic-ui';
import * as animationData from '../images/forbidden.json';
import Lottie from 'react-lottie';
import { useStyles as useErrorPageStyles } from '../Error/ErrorPage';

const FORBIDDEN = 'Forbidden';
const WIDTH = 176;

const WebformForbidden = () => {
  const classes = useErrorPageStyles();
  const lottieRef = React.useRef(null);
  // Support optional chaining (https://github.com/facebook/flow/issues/4303)
  // $FlowIgnore
  const handleClickToPause = () => lottieRef?.current?.handleClickToPause?.();

  return (
    <Grid alignItems="center" container direction="column">
      {/*
       * The `eventListeners` prop is not working
       * https://github.com/chenqingspring/react-lottie/issues/89
       */}
      <div onMouseEnter={handleClickToPause} onMouseLeave={handleClickToPause}>
        <Lottie
          ariaLabel={FORBIDDEN}
          ariaRole="img"
          height={WIDTH}
          isClickToPauseDisabled
          options={{
            animationData,
            autoplay: false,
            loop: true,
            rendererSettings: { preserveAspectRatio: 'xMidYMid meet' }
          }}
          ref={lottieRef}
          width={WIDTH}
        />
      </div>
      <Header2>
        <FormattedMessage
          defaultMessage="Oops! You need permission."
          id="webform.forbidden.header"
        />
      </Header2>
      <BaseText className={classes.description}>
        <FormattedMessage
          defaultMessage="You don't currently have permission to view this web form."
          id="webform.forbidden.description"
        />
        <br />
        <br />
        <FormattedMessage
          defaultMessage="Contact the Workflow owner if you think this was a mistake."
          id="webform.forbidden.action"
        />
      </BaseText>
    </Grid>
  );
};
WebformForbidden.displayName = 'WebformForbidden';
export default WebformForbidden;
